__turbopack_context__.v({
  "codeBlock": "TsU9Gq_codeBlock",
  "description": "TsU9Gq_description",
  "expandAllButton": "TsU9Gq_expandAllButton",
  "layoutWrapper": "TsU9Gq_layoutWrapper",
  "noHeader": "TsU9Gq_noHeader",
  "note": "TsU9Gq_note",
  "offsetAnchor": "TsU9Gq_offsetAnchor",
  "request": "TsU9Gq_request",
  "schema": "TsU9Gq_schema",
  "schemaHeader": "TsU9Gq_schemaHeader",
  "schemaRouteHidden": "TsU9Gq_schemaRouteHidden",
  "stickyHeader": "TsU9Gq_stickyHeader",
  "tableHeader": "TsU9Gq_tableHeader",
  "tableHeaderButtonWrapper": "TsU9Gq_tableHeaderButtonWrapper",
  "tableHeaderWrapper": "TsU9Gq_tableHeaderWrapper",
  "tableHeaderWrapperNoPadding": "TsU9Gq_tableHeaderWrapperNoPadding",
});
